import React  from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import { classnames } from 'Utils/classnames';

const HorseRacingAtrium = ({ onClick, selectedBet, isBetslipvalid, selectedHippodrome, selectedHorseLegsState }) => {
  const isEmpty = selectedHorseLegsState?.every(item => item === undefined || item === null);

  const betSlipButtonClass = classnames({
    'horse-racing-betslip__atrium': true,
    'horse-racing-betslip__atrium--valid': isBetslipvalid,
    'horse-racing-betslip__atrium--empty': selectedHorseLegsState.length === 0,
  });

  return (
    <Button title={ 'AltılıGanyan' } className={ betSlipButtonClass } onClick={ onClick }>
      { selectedHorseLegsState.length !== 0 && <div className="horse-racing-betslip__atrium--game-type">
        { isEmpty || !selectedHippodrome?.name ? 'Hipodrom' : selectedHippodrome.name }
      </div> }
      <div className="horse-racing-betslip__atrium--value">
        { isEmpty || !selectedBet?.descriptionAbbr ? 'Kupon' : selectedBet.descriptionAbbr }
      </div>
    </Button>
  );
};

HorseRacingAtrium.propTypes = {
  selectedBet: PropTypes.object,
  selectedHorseLegsState: PropTypes.array,
  onClick: PropTypes.func,
  isBetslipvalid: PropTypes.bool,
  selectedHippodrome: PropTypes.string
};

export default HorseRacingAtrium;
